module.exports = __webpack_public_path__ + "static/media/single-cart.37956a09.svg";